module.exports = __webpack_public_path__ + "static/media/opened_eye.a2d986a1.png";